import backgroundStyles from './Background.scss';
export const gradientToClassName = (gradient?: number): string =>
  gradient === undefined ? '' : backgroundStyles[`gradient-type-${gradient}`];
